import React, { ChangeEvent } from 'react'
import { useFilters } from '../../context'
import { SortEnum } from '../../types'

export const ProductSort: React.FC = () => {
  const { title, sort, setSort } = useFilters()

  const handleSortChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value as SortEnum
    setSort(value)
  }

  return (
    <div className="productlist-top">
      <div className="productlist-titlewrap">
        <h1 className="productlist-title">{title}</h1>
      </div>
      <div className="productlist-dropdowns">
        <div className="productlist-dropdown ">
          <div className="sortdrop">
            <span className="sortdrop-title">Sort by</span>
            <select
              className="sortdrop-select"
              value={sort}
              onChange={handleSortChange}
            >
              <option value={SortEnum.Recommended}>Recommended</option>
              <option value={SortEnum.SeatType}>Seat Type</option>
              <option value={SortEnum.Range}>Range</option>
              <option value={SortEnum.Lowest}>Lowest Price First</option>
              <option value={SortEnum.Highest}>Highest Price First</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  )
}
